import { render, staticRenderFns } from "./TogetherDia.vue?vue&type=template&id=d58984b8&scoped=true"
import script from "./TogetherDia.vue?vue&type=script&lang=js"
export * from "./TogetherDia.vue?vue&type=script&lang=js"
import style0 from "./TogetherDia.vue?vue&type=style&index=0&id=d58984b8&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58984b8",
  null
  
)

export default component.exports